import listService from '../../../service/ListService';
import util from '../../../service/util/Util';
import mobileAdjustment from "../GeneralMobileAdjustments";
import restService from 'RestService';

class MobilePictureControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        let img = element.find('img:first')[0];
        let picture = listService.getObject(control.id);
        let stretch = util.isTrue(picture.model.attributes.stretch);
        let maintainAspectRatio = util.isTrue(picture.model.attributes.maintainAspectRatio);
        const imageUrl = picture.model.attributes.assetId && picture.model.attributes.assetId.toLowerCase() !== 'none' ? restService.getAssetURL(picture.model.attributes.assetId) : null;

        img.src = imageUrl;
        img.alt = picture.model.attributes.controlName;
        element.css("text-align", "left");

        if (!stretch && !maintainAspectRatio) {
            // -> If nothing is checked - native width / native height / aligned left
            img.style.width = "";
            img.style.height = "";
            img.style.display = "block";
        }
        else if (stretch && !maintainAspectRatio) {
            // -> If stretch property was selected - width 100% / native height
            img.style.height = "";
            img.style.maxWidth = "";
        }
        else if (!stretch && maintainAspectRatio) {
            // -> If maintain aspect ratio was selected - native width / native height / aligned center
            img.style.height = "";
            img.style.width = "";
        }
        else if (stretch && maintainAspectRatio) {
            // -> If stretch AND maintain aspect ratio checked - width 100% / height relative to width 
            img.style.width = "100%";
            img.style.maxWidth = "";
            img.style.maxHeight = "";
            img.style.height = "";
            img.parentElement.style.height = '';            
        }
    }
}

const mobileIPictureControlView = new MobilePictureControlView();
export default mobileIPictureControlView;